import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { GET_GL_MASTER_DATA } from "./apiRoutes";

interface UseGetGlMasterProps {
  communityId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getGlMasterData = async (communityId: string) =>
  await axiosAuth.get(`${GET_GL_MASTER_DATA}/community/${communityId}`);

const useGetGlMasterData = ({
  communityId,
  queryParams,
}: UseGetGlMasterProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["gl-master-data", communityId],
    queryFn: () => getGlMasterData(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!communityId,
    ...queryParams,
  });
};

export default useGetGlMasterData;
